import { sortJobOpening } from '../../../../utils/types/JobOpenings';
import { IJobOpeningsDraftFilters } from '../interfaces';

export const JOB_OPENINGS_TAB_VALUES = {
  ACTIVE: 'Active Job Openings',
  CLOSED: 'Closed Job Openings',
} as const;

export const DEFAULT_PAGE_SIZE = 10;

export const DEFAULT_SORT: sortJobOpening = {
  creationDate: 'desc',
};

export const DEFAULT_DRAFT_FILTERS: IJobOpeningsDraftFilters = {
  jobTitle: '',
  jobReferenceNumber: '',
  hiringManager: undefined,
  internalRecruiter: undefined,
  tags: [],
  dateRange: { startDate: null, endDate: null },
  status: undefined,
};

export const GLASS_PANEL_SX = {
  bgcolor: 'background.paper',
  borderRadius: 0.5,
  border: '1px solid',
  borderColor: 'grey.200',
  boxShadow: '0 4px 20px -2px rgba(0, 0, 0, 0.05)',
  overflow: 'hidden',
};
